module.exports = __webpack_public_path__ + "assets/media/three-circles.93e6c63a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CustomMessage/three-circles.svg
// module id = 2111
// module chunks = 0